import { Colors } from "../../../../styles/theme";
import platformStyles from "../Platform/Platform.styles";

const styles = {
  GetStarted_grid: {
    ...platformStyles.Platform_grid,
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      sm: "repeat(2, minmax(0, 1fr))",
      lg: "repeat(2, minmax(0, 1fr))",
    },
  },
  GetStarted_number: {
    color: Colors.primary,
    fontSize: "1rem",
    fontWeight: 800,
    letterSpacing: 0,
    lineHeight: 1,
  },
  GetStarted_action: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    mt: { xs: 3, sm: 4 },
  },
  GetStarted_downloadButton: {
    margin: 0,
    fontWeight: 700,
  },
};

export default styles;
